<template>
  <div class="dialog">
    <private-dialog
      v-model="show"
      :before-close="beforeClose"
      :show-cancel-button="showCancelButton"
      :show-confirm-button="showConfirmButton"
      :close-on-click-overlay="closeOnClickOverlay"
      :confirmButtonText="confirmButtonText"
      :cancelButtonText="cancelButtonText"
      class="modal"
      :title="title"
    >
        <!-- <img class="close" @click="close" src="@img/modal-close.png" alt="" /> -->
        <!-- <img class="tip" src="@img/modal-tip.png" alt="" /> -->
        <div class="message" v-html="message"></div>
    </private-dialog>
  </div>
</template>

<script>
  import { Dialog } from "vant";

  export default {
    name: 'Modal',
    components: {
      "private-dialog": Dialog.Component
    },
    data() {
      return {
        show: false,
        tips: "",
        icon: "",
        message: "",
        showCancelButton: false /* 是否展示取消按钮 */,
        showConfirmButton: false /* 是否展示确认按钮 */,
        closeOnClickOverlay: false /* 是否在点击遮罩层后关闭弹窗 */,
        cancelButtonText: '确认',
        confirmButtonText: '取消',
        onClose: null,
        duration: 2000,
        title: "提示"
      }
    },
    watch: {
      show(val) {
        const { showCancelButton, showConfirmButton, duration } = this.$data;
        if (val && !showCancelButton && !showConfirmButton) {
          setTimeout(() => {
            this.show = false;
            this.handleCallback("close");
          }, duration);
        }
      }
    },
    methods: {
      beforeClose(action, done) {
        this.show = false;
        done()
        this.handleCallback(action);
      },
      handleCallback(action) {
        if (typeof this.onClose === "function") {
          this.onClose(action)
        }
      },
      close() {
        this.show = false
      }
  }
  }
</script>

<style lang="less" scoped>
  @import "./../../theme/theme.less";
  @import "./../../theme/mixin.less";
  .dialog {
    padding-top: 10px;
    background-color: transparent;
    position: relative;
    .modal {
      .close {
        position: absolute;
        right: 10px;
        top: 12px;
        width: 21px;
      }
      .tip {
        position: absolute;
        left: 20px;
        top: -10px;
        width: 34px;
        z-index: 3333;
      }
    }
    /deep/ .van-dialog {
      width: 72%;
      .van-dialog__header {
        .setOnePxBySide(bottom);
        font-size: 18px;
        padding: 10px 0;
    }
      overflow: inherit;
      border-radius: 15px;
      .van-dialog__footer {
        border-radius: 0 0 15px 15px;
        padding-bottom: 10px;
        &::after{
          display: none;
        }
      }
      
      /deep/ .van-dialog__cancel {
        .van-button__content {
          background: #FFB100;
        }
      }
      .van-dialog__confirm {
        .van-button__content {
          background-color: #3DBF7D;
        }
      }
    }
    .message {
      padding: 15px 0;
      text-align: center;
    }

    /deep/ .van-button{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        .van-button__content {
        width: 90px;
        height: 33px;
        background: #FFB100;
        border-radius: 8px 15px 8px 15px;
        color: #fff;
        }
        &::before {
          display: none;
        }
        &::after{
          display: none;
        }
      }
  
    
  }

</style>


// WEBPACK FOOTER //
// src/components/Modal/Dialog.vue